import { VERSION } from '../environments/version';

export const Version = () => {
  return (
    <div id="app-version" style={{ display: 'none' }}>
      {VERSION}
    </div>
  );
};
